import client from '../httpClient';

const getSchedulesDetailApi = (scheduleId, modifyObj) => {
  return client.get(`/schedules/${scheduleId}`, JSON.stringify(modifyObj));
};

export default getSchedulesDetailApi;
